<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  status: {
    type: String,
    default: '',
  },
});

const { t } = useI18n();

const statusConfig = computed(() => ({
  queued: {
    class: 'bg-n-slate-3 text-n-slate-11',
    label: t('CAMPAIGN.WHATSAPP.ANALYTICS.STATUS.QUEUED'),
  },
  sent: {
    class: 'bg-n-blue-3 text-n-blue-11',
    label: t('CAMPAIGN.WHATSAPP.ANALYTICS.STATUS.SENT'),
  },
  delivered: {
    class: 'bg-n-teal-3 text-n-teal-11',
    label: t('CAMPAIGN.WHATSAPP.ANALYTICS.STATUS.DELIVERED'),
  },
  read: {
    class: 'bg-n-iris-3 text-n-iris-11',
    label: t('CAMPAIGN.WHATSAPP.ANALYTICS.STATUS.READ'),
  },
  failed: {
    class: 'bg-n-ruby-3 text-n-ruby-11',
    label: t('CAMPAIGN.WHATSAPP.ANALYTICS.STATUS.FAILED'),
  },
  skipped: {
    class: 'bg-n-amber-3 text-n-amber-11',
    label: t('CAMPAIGN.WHATSAPP.ANALYTICS.STATUS.SKIPPED'),
  },
}));

const badgeClass = computed(
  () =>
    statusConfig.value[props.status]?.class || statusConfig.value.queued.class
);

const label = computed(
  () => statusConfig.value[props.status]?.label || props.status
);
</script>

<template>
  <span
    class="inline-flex items-center h-6 px-2 rounded-md text-xs font-medium whitespace-nowrap"
    :class="badgeClass"
  >
    {{ label }}
  </span>
</template>
